export default "__VITE_ASSET__CDmZmCTa__"